import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { AppContext } from "../../App";
import { CircularProgress } from "@mui/material";


export default function UploadCard(props){

  const { eventDetails, setPromoterUpdates } = useContext(AppContext)

  const eventDocs = props.docList
  const docObj = eventDocs.find(o => o.docName === props.name)

  const [selectedDoc, setSelectedDoc] = useState("")

  const [uploading, setUploading] = useState(false)

  const id = eventDetails.eventID

  const url = "https://api.cloudinary.com/v1_1/craigycraig/image/upload"

  async function postToDb(){
    const dbURL = [`https://res.cloudinary.com/craigycraig/image/upload/event_documents/${id}-${props.name}.pdf`]

    await fetch(`https://the-paper-pusher.herokuapp.com/promoterUpload/${id}/${props.name}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(dbURL)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
  }
  
  function uploadFile(){
    setUploading(true)

    const formData = new FormData()
    formData.append(`file`, selectedDoc)
    formData.append('upload_preset', 'vsackasi')
    formData.append('public_id', `${id}-${props.name}`)

    fetch(url, {
      method: "POST",
      body: formData
    })
      .then((response) => {
        console.log(response);
      })
      .then(()=>console.log("File successfully uploaded"))
      .then(postToDb())
      .then(setUploading(false))
      .then(setSelectedDoc(""))
      .then(setPromoterUpdates(prev=>prev+1))
  }

  

  useEffect(()=> {
    console.log(selectedDoc)
  },[selectedDoc])

  

  return (
    <Card sx={{ minWidth: 0 }} elevation={2}>
      <Typography sx={{marginTop:'1em', mb: 1.5, marginLeft:'1em', marginRight: '1em' }} color="text.secondary">
        {props.title}
      </Typography>
      {uploading ? 
      <CircularProgress /> : props.icon
      }
      <CardActions>
        {docObj.docURL === ''
        ? 
        <div>
          <Button sx={{fontSize:'0.8em', color: 'red'}} component="label" size="small" type="file">Upload
          <input onChange={(e)=> setSelectedDoc(e.target.files[0])} type={'file'} hidden /></Button>
          <Button disabled={selectedDoc === ""} sx={{fontSize:'0.8em'}} size="small" type="file" onClick={uploadFile}>Submit</Button>
        </div>
        :
        <a href={docObj.docURL} className="card-links" target="_blank" ><Button sx={{fontSize:'0.8em'}} size="small">View</Button></a>
      }
        
      </CardActions>
    </Card>
  )}